export default __webpack_public_path__ + "b0a8ba44a1521e17bce0b4fcd9ab2828.svg";